class Product {
    constructor(data) {
        for (const property in data) {
            if (data.hasOwnProperty(property)) {
                this[property] = data[property];
            }
        }
        this.wishCount = 0;
    }

    isProductCountAllowed(sizeId, increase) {
        let count = (increase) ? 1 : -1;
        let productSize;

        if (sizeId) {
            productSize = this.getSize(sizeId);

            if (!productSize) {
                return false;
            }

            if (typeof productSize.wishCount !== 'undefined') {
                count += productSize.wishCount;
            }
        } else {
            count += this.wishCount;
        }

        if ((productSize && !productSize.stock) || (!productSize && !this.stock)) {
            return false;
        }

        if (count < 0) {
            return false;
        }

        if ((productSize && productSize.stock < count) || (!productSize && this.stock < count)) {
            return false;
        }

        return true;
    }

    getProductCount(sizeId) {
        let count = 0;

        if (sizeId) {
            const size = this.getSize(sizeId);
            count = size ? size.amount : 0;
        } else {
            count = this.detailData ? this.detailData.amount : 0;
        }

        count = (typeof count === 'undefined') ? 0 : count;
        return count;
    }

    setProductCount(sizeId, value) {
        const size = this.getSize(sizeId);

        if (sizeId) {
            size.amount = value;
        } else {
            this.detailData.amount = value;
        }
    }

    isProductCountDecreasePossible(sizeId) {
        return this.isProductCountAllowed(sizeId, false);
    }

    isProductCountIncreasePossible(sizeId) {
        return this.isProductCountAllowed(sizeId, true);
    }

    wishCountIncrease(sizeId) {
        if (this.isProductCountIncreasePossible(sizeId)) {
            if (sizeId) {
                const productsize = this.getSize(sizeId);

                if (!productsize.wishCount) {
                    productsize.wishCount = 0;
                }

                productsize.wishCount++;
            } else {
                this.wishCount++;
            }
        }
    }

    wishCountDecrease(sizeId) {
        if (this.isProductCountDecreasePossible(sizeId)) {
            if (sizeId) {
                const size = this.getSize(sizeId);

                if (size) {
                    size.wishCount--;

                    if (size.wishCount < 0) {
                        size.wishCount = 0;
                    }
                }
            } else {
                this.wishCount--;

                if (this.wishCount < 0) {
                    this.wishCount = 0;
                }
            }
        }
    }

    getWishCount(sizeId) {
        let wishCount = this.wishCount;

        if (sizeId) {
            const size = this.getSize(sizeId);

            if (size) {
                wishCount = size.wishCount ? size.wishCount : 0;
            }
        }

        return wishCount;
    }

    setWishesToAmount() {
        const productSizes = this.getSizes();

        if (this.detailData && productSizes) {
            for (const index in productSizes) {
                const size = this.getSize(index);

                if (size) {
                    size.amount = size.wishCount;
                }
            }
        }

        this.detailData.amount = this.wishCount;
    }

    getTotalWishCount() {
        let wishCount = this.wishCount;

        for (const index in this.getSizes()) {
            if (this.getSize(index)) {
                wishCount += this.getWishCount(parseInt(index));
            }
        }

        return wishCount;
    }

    setAmountToWishes() {
        const productSizes = this.detailData.productsizes;

        if (this.detailData && productSizes) {
            for (const index in productSizes) {
                const size = this.getSize(index);

                if (size) {
                    let amount = size.amount;

                    if (typeof amount === 'undefined' || amount === null) {
                        amount = 0;
                    }

                    size.wishCount = amount;
                }
            }
        }

        this.wishCount = this.detailData.amount;
    }

    getSize(sizeId) {
        return this.detailData
            && this.detailData.productsizes
            && this.detailData.productsizes[sizeId]
            ? this.detailData.productsizes[sizeId] : null;
    }

    hasSizes() {
        let has = false;
        const productSizes = this.getSizes();

        for (const index in productSizes) {
            if (this.getSize(index)) {
                has = true;
                break;
            }
        }

        return has;
    }

    getSizes() {
        return this.detailData && this.detailData.productsizes ? this.detailData.productsizes : [];
    }
}

export default Product;
